import React, { useState } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import BasePage from "./pages/BasePage";
import AuthorizePage from "./pages/auth/AuthorizePage";

import TokenPage from "./pages/auth/TokenPage";
import LogoutPage from "./pages/auth/LogoutPage";
import { IsAuthorized, GetRole } from "../utils/AuthUtils";
import config from "../settings";
import EndSessionPage from "./pages/auth/EndSessionPage";
import UnauthorizedPage from "./pages/auth/UnauthorizedPage";

export function Routes() {
  return (
    <Switch>
      console.log(config.loginCallbackUrl) console.log(window.location.pathname
      )
      <Route path="/logout" component={LogoutPage} />
      <Route path="/token" component={TokenPage} />
      <Route path="/endsession" component={EndSessionPage} />
      <Route path="/unauthorized" component={UnauthorizedPage} />
      {window.location.pathname === config.loginCallbackUrl ? (
        <Route>
          <TokenPage />
        </Route>
      ) : !IsAuthorized() ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthorizePage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect
          from="/authorization"
          to={window.sessionStorage.getItem("ingressPath") || "/"}
        />
      )}
      {!IsAuthorized() ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/authorization/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
    //         <Switch>

    //             <Route path="/logout" component={LogoutPage}/>
    //             <Route exact path="/unauthorized" component={UnauthorizePage}/>
    //             <Route exact path="/endsession" component={EndSessionPage}/>
    //             <Route path="/feed" component={FeedPage} />
    //             <Route path="/management" component={ManagementPage} />
    //             <Route path="/verify" component={VerifyPage} />
    //             <Route path="/search" component={SearchPage} />
    //             <Route path="/audit" component={AuditPage} />
    //             {/* {window.location.search.substr(1,3)==="pip" ? ( <Route>
    //                     <TokenPage />
    //                 </Route>):(null)} */}

    //             {/* {window.location.pathname === config.loginCallbackUrl ? ( */}

    //             {IsAuthorized() ? (
    //                 /*Redirect to `/auth` when user is not authorized*/
    //                 <Redirect to="/authorization/login"/>
    //             ) : (
    //                 (!GetRole()) ?
    //                 /* unauthorized */
    //                 (<></>) :
    //                 (<Layout>
    //                     <BasePage/>
    //                 </Layout>)
    //             )}
    // <Layout>
    //                     <BasePage/>
    //                 </Layout>)
    //            <Route component={NotFound} />

    //         </Switch>
  );
}
